import { render, staticRenderFns } from "./BaseCheckboxV2.vue?vue&type=template&id=2f816bea&scoped=true&"
import script from "./BaseCheckboxV2.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckboxV2.vue?vue&type=style&index=0&id=2f816bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f816bea",
  null
  
)

export default component.exports